import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

// Jenn, 2026-10-08: the goal ladder's Today rung is a number of "moves" a day
// (one post across all platforms = 1 move; a meeting about a lead magnet
// workshop = 1). Log them here so each day shows as met or not.
const shortDay = (ymd) => new Date(`${ymd}T12:00:00`).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
const addDays = (ymd, n) => { const d = new Date(`${ymd}T12:00:00`); d.setDate(d.getDate() + n); return d.toLocaleDateString('en-CA'); };

export default function MovesLog({ target }) {
  const [data, setData] = useState(null);
  const [note, setNote] = useState('');
  const [date, setDate] = useState('');
  const [msg, setMsg] = useState('');

  const load = useCallback(() => {
    api.get('/admin/sales-marketing/moves').then(r => { setData(r.data); setDate(d => d || r.data.today); }).catch(() => setMsg('Could not load moves.'));
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!data) return null;
  const goal = Number(target) || 0;
  const byDay = {};
  for (const m of data.moves) (byDay[m.date] ||= []).push(m);
  const days = Array.from({ length: 7 }, (_, i) => addDays(data.today, -i)); // today first
  const metDays = days.filter(d => goal > 0 && (byDay[d]?.length || 0) >= goal).length;

  const add = async (e) => {
    e.preventDefault();
    setMsg('');
    try {
      await api.post('/admin/sales-marketing/moves', { date, note });
      setNote('');
      load();
    } catch (err) {
      setMsg(err.response?.data?.error || 'Could not save that move.');
    }
  };
  const remove = async (id) => {
    if (!window.confirm('Remove this move?')) return;
    await api.delete(`/admin/sales-marketing/moves/${id}`).catch(() => {});
    load();
  };

  return (
    <div style={{ marginTop: 16 }}>
      <p className="q" style={{ fontSize: 14 }}>Today's moves</p>
      <p className="qs">Goal: {goal} a day · met on {metDays} of the last 7 days</p>
      <div style={{ marginTop: 8 }}>
        {days.map(d => {
          const list = byDay[d] || [];
          const met = goal > 0 && list.length >= goal;
          if (d !== data.today && list.length === 0) return null;
          return (
            <div key={d} style={{ padding: '6px 0', borderTop: '1px solid #eee' }}>
              <div className="t" style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <b>{d === data.today ? 'Today' : shortDay(d)}</b>
                <span style={{ color: met ? 'var(--forest)' : '#888', fontWeight: 600 }}>{list.length} of {goal}{met ? ' ✓ Met' : ''}</span>
              </div>
              {list.map(m => (
                <div key={m.id} style={{ fontSize: 12, color: '#555', display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                  <span>• {m.note}</span>
                  <button type="button" className="btn s" onClick={() => remove(m.id)} title="Remove">×</button>
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <form onSubmit={add} className="row" style={{ flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
        <label className="fld">What was the move?<input value={note} onChange={e => setNote(e.target.value)} placeholder="e.g. Posted on social media" required /></label>
        <label className="fld">Day<input type="date" value={date} max={data.today} onChange={e => setDate(e.target.value)} /></label>
        <button type="submit" className="btn p s">+ Add a move</button>
      </form>
      {msg && <div className="note">{msg}</div>}
    </div>
  );
}
